import React, { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";

export default function Reports() {
  const [tab, setTab] = useState("tb");
  const [tb, setTb] = useState(null);
  const [pl, setPl] = useState(null);
  const [bs, setBs] = useState(null);

  useEffect(() => {
    api.get("/reports/trial-balance").then((r) => setTb(r.data));
    api.get("/reports/pl").then((r) => setPl(r.data));
    api.get("/reports/balance-sheet").then((r) => setBs(r.data));
  }, []);

  return (
    <div className="space-y-5 lb-fade" data-testid="reports-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Financial Reports</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Reports</h1>
      </div>

      <div className="lb-card">
        <div className="flex border-b border-neutral-200">
          {[
            { k: "tb", l: "Trial Balance" },
            { k: "pl", l: "Profit & Loss" },
            { k: "bs", l: "Balance Sheet" },
          ].map((t) => (
            <button key={t.k} onClick={() => setTab(t.k)}
                    data-testid={`rep-tab-${t.k}`}
                    className={"px-4 py-3 text-sm font-semibold border-b-2 " +
                      (tab === t.k ? "border-[#0A66C2]" : "border-transparent text-neutral-500 hover:text-[#0A66C2]")}>
              {t.l}
            </button>
          ))}
        </div>

        <div className="p-5">
          {tab === "tb" && tb && (
            <table className="lb-table">
              <thead>
                <tr><th>Ledger</th><th className="text-right">Debit</th><th className="text-right">Credit</th><th className="text-right">Balance</th></tr>
              </thead>
              <tbody>
                {tb.rows.map((r) => (
                  <tr key={r.ledger}>
                    <td className="font-semibold">{r.ledger}</td>
                    <td className="amt">{fmtINR(r.debit)}</td>
                    <td className="amt">{fmtINR(r.credit)}</td>
                    <td className="amt font-semibold">{fmtINR(Math.abs(r.balance))} <span className="text-xs">{r.balance_type}</span></td>
                  </tr>
                ))}
                <tr className="font-bold bg-neutral-50">
                  <td>Total</td>
                  <td className="amt">{fmtINR(tb.total_debit)}</td>
                  <td className="amt">{fmtINR(tb.total_credit)}</td>
                  <td className="amt">
                    {Math.abs(tb.total_debit - tb.total_credit) < 0.01 ? (
                      <span className="text-emerald-600">Balanced ✓</span>
                    ) : (
                      <span className="text-rose-600">Diff {fmtINR(tb.total_debit - tb.total_credit)}</span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {tab === "pl" && pl && (
            <div className="grid grid-cols-3 gap-4">
              <div className="lb-kpi"><div className="lb-kpi-label">Income</div><div className="lb-kpi-value mono text-emerald-600">{fmtINR(pl.income)}</div></div>
              <div className="lb-kpi"><div className="lb-kpi-label">Expenses</div><div className="lb-kpi-value mono text-rose-600">{fmtINR(pl.expenses)}</div></div>
              <div className="lb-kpi"><div className="lb-kpi-label">Net Profit</div>
                <div className={"lb-kpi-value mono " + (pl.net_profit >= 0 ? "text-emerald-600" : "text-rose-600")}>
                  {fmtINR(pl.net_profit)}
                </div>
              </div>
            </div>
          )}

          {tab === "bs" && bs && (
            <div className="grid grid-cols-2 gap-6">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-neutral-500 font-semibold mb-2">Assets</div>
                <table className="lb-table">
                  <tbody>
                    {Object.entries(bs.assets).map(([k, v]) => (
                      <tr key={k}><td>{k}</td><td className="amt">{fmtINR(v)}</td></tr>
                    ))}
                    <tr className="font-bold bg-neutral-50"><td>Total Assets</td><td className="amt">{fmtINR(bs.total_assets)}</td></tr>
                  </tbody>
                </table>
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-wider text-neutral-500 font-semibold mb-2">Liabilities & Equity</div>
                <table className="lb-table">
                  <tbody>
                    {Object.entries(bs.liabilities).map(([k, v]) => (
                      <tr key={k}><td>{k}</td><td className="amt">{fmtINR(v)}</td></tr>
                    ))}
                    <tr><td>Retained Earnings</td><td className="amt">{fmtINR(bs.retained_earnings)}</td></tr>
                    <tr className="font-bold bg-neutral-50">
                      <td>Total Liab + Equity</td>
                      <td className="amt">{fmtINR(bs.total_liabilities + bs.retained_earnings)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
